import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalComponent } from './modal.component';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

@NgModule({
    declarations: [ModalComponent],
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
    ],
    exports: [ModalComponent],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
    ]
})
export class ModalModule {}